import React, {useContext} from 'react';
import {
    makeStyles,
    Tab,
    Tabs,
} from "@material-ui/core";
import {helpFormReasons} from "../../configs/complianceReasons";
import {IHelpFormReasons} from "../../interfaces/assistanceContext";
import {AppContext} from "../../utils/appContext";
import 'line-awesome/dist/line-awesome/css/line-awesome.css';
import {Hidden} from "@mui/material";
import {useTranslation} from "react-i18next";

export const SelectableCardHelp = () => {

    const appContext = useContext(AppContext);

    const handleChange = (event: any, newValue: number) => {
        appContext.setHelpReason(newValue)
    };

    const useStyles = makeStyles({
        tabRoot: {
            '& .MuiTab-root': {
                minWidth: 'auto!important',
                margin: '0!important',
                '& i': {
                    fontSize: 30
                },
                textTransform: 'initial!important'
            },
            '& .MuiTabs-indicator': {
                height: '4px',
                backgroundColor: '#FFEB34'
            }
        }
    });

    const classes = useStyles();
    const {t} = useTranslation();

    return (
        <>
            <Hidden smDown>
                <Tabs value={appContext.helpReason} onChange={handleChange} aria-label="icon label tabs example" className={classes.tabRoot} variant="scrollable">
                    {
                        helpFormReasons.map((reason: IHelpFormReasons, index: number) => (
                            <Tab icon={reason.icon} label={t(reason.title)} key={index} />
                        ))
                    }
                </Tabs>
            </Hidden>
            <Hidden smUp>
                <Tabs value={appContext.helpReason} onChange={handleChange} aria-label="icon label tabs example" className={classes.tabRoot} variant="scrollable">
                    {
                        helpFormReasons.map((reason: IHelpFormReasons, index: number) => (
                            <Tab icon={reason.icon} label={t(reason.title)} key={index} />
                        ))
                    }
                </Tabs>
            </Hidden>
        </>
    );
};
